import { render, staticRenderFns } from "./imgL.vue?vue&type=template&id=d32c1ca6"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d32c1ca6')) {
      api.createRecord('d32c1ca6', component.options)
    } else {
      api.reload('d32c1ca6', component.options)
    }
    module.hot.accept("./imgL.vue?vue&type=template&id=d32c1ca6", function () {
      api.rerender('d32c1ca6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholders/imgL.vue"
export default component.exports